module.exports = __webpack_public_path__ + "static/img/interaktivarum.73de89b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/interaktivarum.png
// module id = d2T8
// module chunks = 0